<template>
  <bankChannelTab>
    <template v-slot="{ channelType }">
      <div>
        <base-list-management
          v-if="channelType === bankChannelType"
          ref="baseListManagement"
          :configData.sync="configData"
        >
          <div slot="custom-operate">
            <el-button
              type="primary"
              size="small"
              @click="addAccount"
              v-if="
                checkBankChannelPermission(
                  'addPartnerAccount',
                  'addPartnerAccountWangshang',
                  channelType
                )
              "
            >
              新增账户
            </el-button>
          </div>
        </base-list-management>
        <partnerAccountDialog
          v-model="partnerAccountDialog.show"
          :isEdit="partnerAccountDialog.isEdit"
          :accountId="partnerAccountDialog.accountId"
          :channelType="bankChannelType"
          @submitSucc="refreshList"
        />
        <bindBankCardDialog
          ref="bindBankCardDialog"
          @bindBankCardSucc="bindBankCardSucc"
        />
        <!-- 启用、停用二次弹窗 -->
        <dialogWrap
          v-model="confirmDialog.show"
          title="提示"
          width="500px"
          custom-class="confirm-dialog"
        >
          <div v-if="confirmDialog.type === ENUM.STATE_ENUM.disable">
            确定启用“{{ confirmDialog.merchantName }}”的子户配置？
          </div>
          <div v-else-if="confirmDialog.type === ENUM.STATE_ENUM.enable">
            请您确定是否需要停用“{{ confirmDialog.merchantName }}”账户？
          </div>
          <template slot="footer">
            <el-button size="small" @click="confirmDialog.show = false"
              >取消</el-button
            >
            <el-button
              size="small"
              :loading="confirmDialog.loading"
              type="primary"
              @click="submitConfirmHandle"
              >确认</el-button
            >
          </template>
        </dialogWrap>
      </div>
    </template>
  </bankChannelTab>
</template>

<script>
import bankChannelTab from '@/pages/finance/bankChannelTab'
// eslint-disable-next-line import/no-cycle
import config from './config'
import ENUM from './enum'
import partnerAccountDialog from './partnerAccountDialog'
import bindBankCardDialog from './bindBankCardDialog'
import { modifySubAccountState, submitSubAccount } from '@/api/domain/finance'
import { mapGetters } from 'vuex'

export default {
  components: { bankChannelTab, partnerAccountDialog, bindBankCardDialog },
  data() {
    const { configData } = config.call(this)
    return {
      configData,
      partnerAccountDialog: {
        show: false,
        isEdit: false,
        accountId: 0,
      },
      confirmDialog: {
        show: false,
        loading: false,
        type: '',
        merchantName: '',
        accountId: '',
      },
      ENUM,
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    handleState(row) {
      this.confirmDialog = {
        type: row.state,
        merchantName: row.merchantName,
        show: true,
        loading: false,
        accountId: row.accountId,
      }
    },
    addAccount() {
      this.partnerAccountDialog.isEdit = false
      this.partnerAccountDialog.show = true
    },
    // eslint-disable-next-line vue/no-unused-properties
    async editAccount(row) {
      this.partnerAccountDialog = {
        show: true,
        isEdit: true,
        accountId: row.accountId,
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    async openAccount(row) {
      const { code, data, msg } = await submitSubAccount({
        accountId: row.accountId,
      })

      if (code === 1) {
        if (data) {
          this.$message.success('开户成功')
        } else {
          this.$message.error(msg)
        }
        this.$refs.baseListManagement.searchForm()
      }
    },
    async submitConfirmHandle() {
      this.confirmDialog.loading = true
      try {
        const { code, data } = await modifySubAccountState({
          accountId: this.confirmDialog.accountId,
          state:
            this.confirmDialog.type === ENUM.STATE_ENUM.enable
              ? ENUM.STATE_ENUM.disable
              : ENUM.STATE_ENUM.enable,
        })
        if (code === 1) {
          if (data.result) {
            this.$message.success(
              `${
                this.confirmDialog.type === ENUM.STATE_ENUM.enable
                  ? '停用'
                  : '启用'
              }成功`,
            )
          } else {
            this.$message.error(data.info)
          }
          this.confirmDialog = {
            show: false,
            type: '',
            merchantName: '',
            loading: false,
            accountId: '',
          }
          this.refreshList()
        } else {
          this.confirmDialog.loading = false
        }
      } catch (error) {
        this.confirmDialog.loading = false
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    bindCardState(row, type) {
      if (this.bankChannelType === 8) {
        this.$refs.bindBankCardDialog.show(row, type)
      } else {
        const formData = {
          accountId: row.accountId,
          merchantName: row.merchantName,
          licenceNo: row.licenceNo,
        }
        this.$router.push({
          name: 'bindBankCard',
          query: {
            data: JSON.stringify(formData),
          },
        })
      }
    },
    refreshList() {
      this.$refs.baseListManagement.searchForm()
    },
    bindBankCardSucc() {
      this.refreshList()
    },
  },
  computed: {
    ...mapGetters(['bankChannelType']),
  },
  mounted() {
    this.configData.formData.formProps.model.channelType = this.bankChannelType
  },
  watch: {
    bankChannelType: {
      handler(val) {
        this.configData.formData.formProps.model.channelType = val
      },
    },
  },
}
</script>
